import React, { FC } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

import LogoDark2x from "../../images/logo-dark2x.png";
import OrgLogo from "./dropdown/OrgLogo";
import Notifications from "./dropdown/Notifications";
import UserDropdown from "./dropdown/UserDropdown";

interface HeaderProps {
  fixed?: boolean;
  className?: string;
}

/**
 * Compact header — buyer's nk-header markup, but explicit inline sizing
 * so it doesn't inherit the tall dashlite "is-regular" default.
 */
const Header: FC<HeaderProps> = ({ fixed, className }) => {
  const headerClass = classNames({
    "nk-header is-light": true,
    "nk-header-fixed": fixed,
    [`${className}`]: !!className,
  });

  return (
    <div
      className={headerClass}
      style={{
        height: 64,
        background: "#fff",
        borderBottom: "1px solid #e5e7eb",
        boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
      }}
    >
      <div className="container-fluid" style={{ height: "100%" }}>
        <div
          className="nk-header-wrap"
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="nk-header-brand">
            <Link
              to="/home"
              className="logo-link"
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <img
                src={LogoDark2x}
                alt="ProcureX"
                style={{ height: 32, width: "auto", display: "block" }}
              />
            </Link>
          </div>

          <div className="nk-header-tools">
            <ul
              className="nk-quick-nav"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                margin: 0,
                padding: 0,
                listStyle: "none",
              }}
            >
              <li className="language-dropdown d-none d-sm-block">
                <OrgLogo />
              </li>
              <li
                className="chats-dropdown"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Notifications />
              </li>
              <li
                className="user-dropdown"
                style={{ display: "flex", alignItems: "center" }}
              >
                <UserDropdown />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
